import { render, staticRenderFns } from "./admin-olimpiada2024.vue?vue&type=template&id=6ab81bba&scoped=true"
import script from "./admin-olimpiada2024.vue?vue&type=script&lang=js"
export * from "./admin-olimpiada2024.vue?vue&type=script&lang=js"
import style0 from "./admin-olimpiada2024.vue?vue&type=style&index=0&id=6ab81bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab81bba",
  null
  
)

export default component.exports